import React from 'react';
import {Outlet} from 'react-router-dom';

const PartnersPageLayout = () => {
    return (
        <><Outlet/></>
    );
};

export default PartnersPageLayout;
